import React from 'react';
import { classNames } from '../helpers/functions';

export const Label = ({ children, description, onClick, className }) =>
	children ? (
		<label
			htmlFor={children}
			className={classNames(
				'block text-xs font-medium text-gray-700 mb-3',
				className
			)}
			onClick={() => (typeof onClick === 'function' ? onClick() : {})}
		>
			{children}
			{description && (
				<span className="text-gray-400 text-xs ml-1">{description}</span>
			)}
		</label>
	) : null;

export const Field = ({ children, className, condensed }) => (
	<div className="sm:col-span-3 h-fit">
		<div className={classNames(className)}>{children}</div>
	</div>
);

export const FormRow = ({
	children,
	className,
	span = 'sm:col-span-3',
	alignRight,
	key,
}) => (
	<div
		className={classNames(
			alignRight ? 'flex justify-end' : '',
			span,
			className
		)}
		key={key}
	>
		{children}
	</div>
);

export const TextField = ({
	id,
	name,
	placeholder,
	defaultValue = '',
	value,
	...props
}) => (
	<input
		type="text"
		name={name}
		id={id}
		className="block w-full rounded-md border-gray-300 shadow-sm focus:border-sky-500 focus:ring-sky-500 sm:text-sm form-item"
		defaultValue={defaultValue}
		value={value}
		placeholder={placeholder}
		{...props}
	/>
);
